import React, { useState, ReactNode } from "react";
import Header from "../components/Header/Header.tsx";
import Sidebar from "../components/Sidebar/Sidebar.tsx";

const DefaultLayout: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [desktopSidebarOpen, setDesktopSidebarOpen] = useState(true);

  return (
    <div className="dark:bg-boxdark-2 dark:text-bodydark">
      <div className="bg-main-background dark:bg-main-background-dark flex h-screen overflow-hidden">
        <Sidebar
          className={`
            fixed
            transition-[width]
            duration-300
            ease-in-out md:static md:shrink-0
            ${desktopSidebarOpen ? "md:w-64" : "md:w-0 md:overflow-hidden"}
          `}
          sidebarOpen={sidebarOpen}
          setSidebarOpen={setSidebarOpen}
          desktopSidebarOpen={desktopSidebarOpen}
          setDesktopSidebarOpen={setDesktopSidebarOpen}
        />

        <div className="relative flex flex-1 flex-col overflow-y-auto overflow-x-hidden">
          <Header
            sidebarOpen={sidebarOpen}
            setSidebarOpen={setSidebarOpen}
            desktopSidebarOpen={desktopSidebarOpen}
            setDesktopSidebarOpen={setDesktopSidebarOpen}
          />

          <main>
            <div className="mx-auto max-w-screen-2xl p-2 md:p-6 2xl:p-10">
              {children}
            </div>
          </main>
        </div>
      </div>
    </div>
  );
};

export default DefaultLayout;
